/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import styled from 'styled-components';
import { classNames } from 'primereact/utils';
// import { Avatar } from 'primereact/avatar';
import { Tooltip } from 'primereact/tooltip';
import { Project } from '@/types/models.ts';
import Avatar from 'boring-avatars';
interface Props {
  className?: string;
  contributors: Project['contributors'];
  small?: boolean;
}

const Div = styled.div`
  & .p-avatar {
    margin-right: -15px;
    & :hover {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      z-index: 100;
      scale: 1.2;
      border-radius: 50%;
      border: 2px solid var(--primary-color-text);
      background-color: var(--green-300);
      transition: all 0.1s ease-in-out;
    }
  }
`;
export const GroupAvatar: React.FC<Props> = ({ className, contributors, small }) => {
  const label = (name: string) => {
    return name
      .split(' ')
      .map((n) => n[0].toUpperCase())
      .join('');
  };

  const uniqueTarget = (name: string) => {
    return `${name.replace(/[^a-zA-Z0-9_]/g, '_')}`;
  };
  return (
    <Div className={classNames(className, 'w-full flex align-items-center')}>
      {contributors.map((contributor, idx) => (
        <div key={idx}>
          <Avatar
            className={classNames(`${uniqueTarget(contributor.name)}`, small ? 'text-sm' : 'text-xl')}
            data-pr-tooltip={`${contributor.name}`}
            data-pr-position="bottom"
            size={small ? 25 : 30}
            variant="pixel"
            name={label(contributor.name)}
            colors={['#222222', '#ffe4c4']}
          />
          <Tooltip className="text-xs" target={`.${uniqueTarget(contributor.name)}`} />
        </div>
      ))}
    </Div>
  );
};
